import React from 'react';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import { workScheduleEventListFetch, workScheduleEventListSetPage, workScheduleEventListUnload } from '../../lib/redux/actions/workScheduleEvents';
import MASpinner from '../../components/common/MASpinner';
import Alert from 'react-bootstrap/Alert';
import Paginator from '../../components/common/Paginator';
import * as ROUTES from '../../lib/routing/frontend';
import WorkScheduleEventTableFilterForm from '../../components/forms/WorkScheduleEvent/WorkScheduleEventTableFilterForm';
import WorkScheduleEventListTable from './WorkScheduleEventListTable';

const mapStateToProps = (state) => ({
  ...state.workScheduleEvents,
});

const mapDispatchToProps = {
  workScheduleEventListFetch,
  workScheduleEventListSetPage,
  workScheduleEventListUnload,
};

class WorkScheduleEventListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  getCombinedFilters() {
    const { filters, defaultFilters = {} } = this.props;
    return { ...filters, ...defaultFilters };
  }

  componentWillUnmount() {
    this.props.workScheduleEventListUnload();
  }

  componentDidMount() {
    this.props.workScheduleEventListFetch(this.getQueryParamPage(), this.getCombinedFilters());
  }

  componentDidUpdate(prevProps) {
    const { currentPage, workScheduleEventListFetch, workScheduleEventListSetPage, filters } = this.props;

    if (prevProps.match.params.page !== this.getQueryParamPage()) {
      workScheduleEventListSetPage(this.getQueryParamPage());
    }
    if (prevProps.currentPage !== currentPage || prevProps.filters !== filters) {
      workScheduleEventListFetch(currentPage, this.getCombinedFilters());
    }
  }

  getQueryParamPage() {
    return Number(this.props.match.params.page) || 1;
  }

  changePage(page) {
    const { history, workScheduleEventListSetPage } = this.props;
    workScheduleEventListSetPage(page);
    history.push(ROUTES.BILLING_CHECKLIST_EVENTS.ALL.replace(':page', page));
  }

  nextPage() {
    const { currentPage, pageCount } = this.props;
    const newPage = Math.min(currentPage + 1, pageCount);
    this.changePage(newPage);
  }

  prevPage() {
    const { currentPage } = this.props;
    const newPage = Math.max(currentPage - 1, 1);
    this.changePage(newPage);
  }

  toggleFilters() {
    this.setState((prevState) => {
      return { showFilters: !prevState.showFilters };
    });
  }

  render() {
    const { workScheduleEvents, isFetchingWorkScheduleEvents, pageTitle, pageCount, currentPage } = this.props;

    return (
      <Card>
        <Card.Header>
          <div className="d-flex justify-content-between">
            {' '}
            {pageTitle}
            {!isFetchingWorkScheduleEvents && workScheduleEvents && workScheduleEvents.length > 0 && (
              <div>
                <button className="btn btn-sm btn-outline-secondary mr-3" onClick={this.toggleFilters.bind(this)}>
                  Filters
                </button>
                <span className="tabular-data-result-count">{pageCount} pages</span>
              </div>
            )}
          </div>
        </Card.Header>

        {this.state.showFilters && (
          <Card.Body className={'mediaccount-filter-wrapper'}>
            <WorkScheduleEventTableFilterForm />
          </Card.Body>
        )}

        {isFetchingWorkScheduleEvents && (
          <Card.Body>
            <MASpinner />
          </Card.Body>
        )}

        {!isFetchingWorkScheduleEvents && (workScheduleEvents === null || workScheduleEvents.length === 0) && (
          <Card.Body>
            <Alert variant={'info'} className="mb-0">
              No Events found
            </Alert>
          </Card.Body>
        )}

        {!isFetchingWorkScheduleEvents && workScheduleEvents && workScheduleEvents.length > 0 && (
          <WorkScheduleEventListTable workScheduleEvents={workScheduleEvents} />
        )}
        {!isFetchingWorkScheduleEvents && workScheduleEvents && workScheduleEvents.length > 0 && (
          <Paginator
            currentPage={currentPage}
            pageCount={pageCount}
            setPage={this.changePage.bind(this)}
            nextPage={this.nextPage.bind(this)}
            prevPage={this.prevPage.bind(this)}
          />
        )}
      </Card>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkScheduleEventListContainer);
